import _ from 'lodash';
import Emittery from 'emittery';
import Promise from 'bluebird';
import { log } from '@swiper/core';

const debug = require( 'debug' )( 'swiper:config:plugins' );

export class Plugins extends Emittery {

  plugins = [];

  constructor( opts={} ) {
    super();
    _.assign( this, opts );
  }

  locate( name ) {
    const paths = [
      `../plugins/${name}`,
      `@swiper/${name}-plugin`,
      `swiper-plugin-${name}`,
    ];
    for ( const path of paths ) {
      try {
        return require.resolve( path );
      } catch( err ) {
        // no-op
      }
    }
    throw new Error( `Unable to locate plugin ${name}` );
  }

  require( name ) {
    const res = require( this.locate( name ) );
    return res.default || res;
  }

  load( name, conf ) {
    const Plugin = this.require( name );
    if ( ! Plugin ) throw new Error( `Unable to load plugin ${name}` );
    if ( typeof Plugin !== 'function' ) {
      log.error( 'Not a function:', Plugin );
      throw new Error( `Plugin ${name} is not a function!` );
    }
    debug( 'Loaded plugin', name );
    return this.register( new Plugin( conf ) );
  }

  register( plugin ) {
    this.plugins.push( plugin );
    return plugin;
  }

  async fire( name, ...args ) {
    debug( 'Firing event', name );
    this.emit( `before${name}`, ...args );
    await this.processEvent( `before${name}`, ...args );
    await this.processEvent( `on${name}`, ...args );
    await this.processEvent( `after${name}`, ...args );
    this.emit( `after${name}`, ...args );
  }

  fireSync( name, ...args ) {
    this.emit( `before${name}`, ...args );
    this.processEventSync( `before${name}`, ...args );
    this.processEventSync( `on${name}`, ...args );
    this.processEventSync( `after${name}`, ...args );
    this.emit( `after${name}`, ...args );
  }

  getPluginsWith( name ) {
    return this.plugins.filter( p => typeof p[ name ] === 'function' );
  }

  async processEvent( name, ...args ) {
    const plugins = this.getPluginsWith( name );
    return Promise.mapSeries( plugins, plugin => plugin[ name ]( ...args ) );
  }

  processEventSync( name, ...args ) {
    const plugins = this.getPluginsWith( name );
    return _.map( plugins, plugin => plugin[ name ]( ...args ) );
  }

}
